<template>
    <div class="container remove-padding-margin">
        <div class="fixed-judul fixed-top">
            <div class="row justify-content-center align-items-center set-row">
                <div class="col-md-2 col-sm-2 col-2 remove-padding" @click="back()">
                    <img src="../../assets/gambar/back-blue.svg" alt="">
                </div>
                <div class="col-md-8 col-sm-8 col-8 text-center remove-padding">Pengaturan Transaksi</div>
                <div class="col-md-2 col-sm-2 col-2 remove-padding"></div>
            </div>
        </div>
        <main class="">
            <div class="flex-100">
                <div class="flex-1 pad-top-50">
                    <div class="add-padding-default">
                        <div class="text-outlets mar-top-20">
                            <h6 class="remove-margin f-14 f-c-midgrey">
                              Anda dapat menambahkan pengaturan untuk transaksi outlet ini.
                            </h6>
                        </div>
                        <div class="custom-control custom-checkbox remove-padding mar-top-12" style="color:#206CFF;">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="checkregulerlunas"
                              v-model="regulerWajibLunas"
                            />
                            <label class="custom-control-label" for="checkregulerlunas">
                              Transaksi Reguler Wajib Lunas
                            </label>
                        </div>

                        <div class="custom-control custom-checkbox remove-padding mar-top-12 mar-bot-12" style="color:#206CFF;">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="checksnapcleanlunas"
                              v-model="dropoffWajibLunas"
                            />
                            <label class="custom-control-label" for="checksnapcleanlunas">
                              Transaksi Snapclean Wajib Lunas
                            </label>
                        </div>

                        <div class="custom-control custom-checkbox remove-padding mar-top-12 mar-bot-12" style="color:#206CFF;">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="checksembunyikandatakonsumen"
                                v-model="hideCustomer"
                            />
                            <label class="custom-control-label" for="checksembunyikandatakonsumen">
                                Sembunyikan data konsumen di kasir
                            </label>
                        </div>

                        <div class="custom-control custom-checkbox remove-padding mar-top-12 mar-bot-12" style="color:#206CFF;">
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="checkwajibupload"
                                v-model="enableWajibBuktiTf"
                            />
                            <label class="custom-control-label" for="checkwajibupload">
                                Wajib upload bukti pembayaran
                            </label>
                        </div>
                    </div>

                    <div class="separator"></div>

                    <div class="add-padding-default">
                        <div class="custom-control custom-switch m-t-16 m-d-16" style="padding: 0px 12px">
                            <input type="checkbox" :disabled="!validateAccess('transactionSetting.update')" class="custom-control-input" id="customSwitchDiskon" v-model="isDiskon">
                            <label class="custom-control-label font-14 font-weight-bold" for="customSwitchDiskon">
                              Diskon
                            </label>
                        </div>
                        <div v-if="isDiskon">
                          <div class="input-group remove-padding">
                              <InputPresentase
                                v-model="diskon"
                                :defaultValue="diskon.raw"
                                v-if="!isRupiah.diskon"
                                :class="'form-control inputs'"></InputPresentase>
                              <div v-if="!isRupiah.diskon" class="input-group-prepend">
                                  <div class="input-group-text">%</div>
                              </div>
                          </div>
                          <ErrorMessage v-if="!isRupiah.diskon" class="error" label="Persentase Diskon" :validation="$v.diskon.raw"></ErrorMessage>

                          <div class="custom-control custom-checkbox remove-padding m-t-16 m-d-16">
                            <input
                              type="checkbox"
                              class="custom-control-input"
                              id="editable_diskon"
                              v-model="editableDiskon">
                            <label class="custom-control-label f-16" for="editable_diskon">Izinkan kasir mengubah diskon</label>
                            <div class="f-regular f-12 f-c-midgrey m-t-16">
                              Diskon akan mengurangi total tagihan yang harus dibayar konsumen.
                              Berlaku untuk semua layanan & transaksi.
                            </div>
                          </div>
                        </div>
                    </div>
                    <div class="separator"></div>

                    <div class="add-padding-default">
                        <div class="custom-control custom-switch m-t-16 m-d-16" style="padding: 0px 12px">
                            <input type="checkbox" :disabled="!validateAccess('transactionSetting.update')" class="custom-control-input" id="customSwitchPajak" v-model="isPajak">
                            <label class="custom-control-label font-14 font-weight-bold" for="customSwitchPajak">
                              Pajak
                            </label>
                        </div>
                        <div v-if="isPajak">
                          <div class="input-group remove-padding">
                            <InputPresentase
                              v-model="pajak"
                              :defaultValue="pajak.raw"
                              v-if="!isRupiah.pajak"
                              :class="'form-control inputs'"
                            />
                            <div class="input-group-prepend" v-if="!isRupiah.pajak">
                                <div class="input-group-text">%</div>
                            </div>
                          </div>
	                        <ErrorMessage class="error" label="Persentase Pajak" :validation="$v.pajak.raw"/>
                          <div class="custom-control custom-checkbox remove-padding m-t-16 m-d-16">
								            <input type="checkbox" class="custom-control-input" id="editable_paja" v-model="editablePajak">
								            <label class="custom-control-label f-16" for="editable_paja">
                              Izinkan kasir mengubah pajak
                            </label>
	                          <div class="f-regular f-12 f-c-midgrey m-t-16">
                              Pajak akan menambah total tagihan yang harus dibayar konsumen.
                              Penerimaan pajak bukan pendapatan.
                            </div>
                          </div>
                        </div>
                    </div>


	                <div class="separator"></div>
	                <div class="add-padding-default">
                        <div class="custom-control custom-switch m-t-16 m-d-16" style="padding: 0px 12px">
                            <input type="checkbox" :disabled="!validateAccess('transactionSetting.update')" class="custom-control-input" id="customSwitchBiaya" v-model="isBiaya">
                            <label class="custom-control-label font-14 font-weight-bold" for="customSwitchBiaya">
                              Biaya Layanan
                            </label>
                        </div>
                        <div v-if="isBiaya">
                            <div class="remove-margin d-flex justify-content-end m-d-4">
	                            <div class="f-semi font-14 f-c-blue" @click="() => { isRupiah.biayaTambahan = !isRupiah.biayaTambahan }">
		                            <span v-html="!isRupiah.biayaTambahan ? 'Ubah ke Rupiah ': 'Ubah ke Persentase '"></span>
		                            <i class="f-14 fas fa-chevron-left"></i>
		                            <i class="f-14 fas fa-chevron-right"></i>
	                            </div>
                            </div>
                            <div class="input-group remove-padding">
                                <InputPresentase
                                  v-model="biaya"
                                  :defaultValue="biaya.raw"
                                  v-if="!isRupiah.biayaTambahan"
                                  :class="'form-control inputs'"
                                />
                                <div class="input-group-prepend" v-if="!isRupiah.biayaTambahan">
                                    <div class="input-group-text">%</div>
                                </div>
                            </div>
	                          <ErrorMessage
                              v-if="!isRupiah.biayaTambahan"
                              class="error"
                              label="Persentase Biaya Layanan"
                              :validation="$v.biaya.raw"
                            />

                            <InputRupiah
                              :outerDivClass="'input-group remove-padding'"
                              v-model="biayaRupiah"
                              :showRp="true"
                              :defaultValue="biayaRupiah.formatted"
                              :placeholder="'14.000'"
                              :comma="false"
                              v-if="isRupiah.biayaTambahan"
                            />
	                          <ErrorMessage v-if="isRupiah.biayaTambahan" class="error" label="Bonus E-payment" :validation="$v.biayaRupiah.raw"/>

                            <div class="custom-control custom-checkbox remove-padding m-t-16 m-d-16">
                              <input
                                type="checkbox"
                                class="custom-control-input"
                                id="editable_biaya"
                                v-model="editableBiaya"
                              />
                              <label class="custom-control-label f-16" for="editable_biaya">
                                Izinkan kasir mengubah biaya layanan
                              </label>
	                            <div class="f-regular f-12 f-c-midgrey m-t-16">
		                            Biaya Layanan akan menambah total tagihan yang harus dibayar konsumen.
		                            Berlaku untuk semua layanan & transaksi.
	                            </div>
                            </div>
                        </div>
                    </div>
	                <div class="add-padding-default" style="display: none">
	                  <div class="separator"></div>
		                <div class="custom-control custom-switch m-t-16 m-d-16" style="padding: 0px 12px">
			                <input type="checkbox" class="custom-control-input" id="customSwitchBiayaPengantaran" v-model="isBiayaPengantaran">
			                <label class="custom-control-label font-14 font-weight-bold" for="customSwitchBiayaPengantaran">
                        Biaya Pengantaran
                      </label>
		                </div>
		                <div v-if="isBiayaPengantaran">
			                <div class="font-14 f-c-midgrey">Tarif Flat</div>
			                <InputRupiah
				                :outerDivClass="'input-group remove-padding'"
				                v-model="biayaPengantaranRupiah"
				                :showRp="true"
				                :defaultValue="biayaPengantaranRupiah.formatted"
				                :placeholder="'14.000'"
				                :comma="false"
				                v-if="isRupiah.biayaPengantaran"
			                />
			                <ErrorMessage v-if="isRupiah.biayaPengantaran" class="error" label="Bonus E-payment" :validation="$v.biayaPengantaranRupiah.raw"/>

			                <div class="custom-control custom-checkbox remove-padding m-t-16 m-d-16">
				                <input
                          type="checkbox"
                          class="custom-control-input"
                          id="editable_biaya_pengantaran"
                          v-model="editableBiayaPengantaran"
                        />
				                <label class="custom-control-label f-16" for="editable_biaya_pengantaran">
                          Izinkan kasir mengubah biaya pengantaran
                        </label>
				                <div class="f-regular f-12 f-c-midgrey m-t-16">
					                Biaya Pengantaran akan menambah total tagihan yang harus dibayar konsumen jika menggunakan layanan antar-jemput.
				                </div>
			                </div>
		                </div>
	                </div>
                  <div class="separator"></div>
                  <div class="add-padding-default">
		                <div class="custom-control custom-switch m-t-16 m-d-16" style="padding: 0px 12px">
			                <input type="checkbox" :disabled="!validateAccess('transactionSetting.update')" class="custom-control-input" id="customSwitchPengerjaanExpress" v-model="pengerjaanExpress.isOpenPaket">
			                <label class="custom-control-label font-14 font-weight-bold" for="customSwitchPengerjaanExpress">
                        Pengerjaan Express
                      </label>
		                </div>
                    <div v-if="pengerjaanExpress.isOpenPaket">
                      <div class="data-list">
                          <div class="list-paket-express p-d-12 card-item" v-for="paket, idx in pengerjaanExpress.listPaket" :key="`paket-express${idx}`">
                            <div>
                              <label class="f-16 f-regular f-c-black m-d-0">{{paket.nama}}</label>
                            </div>
                            <div>
                              <img src="../../../public/assets/img/icons/dots-horizontal-grey.svg" alt=""/>
                            </div>
                            <div>
                              <label class="f-14 f-regular f-c-midgrey m-d-0">{{paket.durasi}} jam <span class="dot f-c-midgrey"></span> Tarif {{paket.tarif}}x</label>
                            </div>
                            <div class="clik"
                                :data-toggle="(validateAccess('transactionSetting.update') || validateAccess('transactionSetting.delete')) && 'dropdown'"
                                aria-haspopup="true"
                                aria-expanded="false">
                            </div>
                            <div class="dropdown-menu garis-listkomisi">
                              <button v-if="validateAccess('transactionSetting.update')" class="dropdown-item icon-2" @click="updatePaket(paket)">
                                <span class="mar-right-10">
                                  <img src="../../assets/icons/edit-20.svg">
                                </span>
                                Ubah
                              </button>
                              <button v-if="validateAccess('transactionSetting.delete')" class="dropdown-item icon-2" @click="deletePaket(paket)">
                                <span class="mar-right-10">
                                  <img src="../../assets/icons/trash-red.svg">
                                </span>
                                Hapus
                              </button>
                            </div>
                          </div>
                      </div>
                      <div class="plus-btn m-t-16">
                        <SOButtonPlusLink
                          v-if="validateAccess('transactionSetting.update')"
                          id="btn-tambah-pengerjaan-express"
                          text="Tambah paket express"
                          @action="addPaket"
                        />
                      </div>
                      <div class="f-regular f-12 f-c-midgrey m-t-16">
                        <label>Pengerjaan express akan mempercepat estimasi penyelesaian dan menambah total tagihan yg harus dibayar konsumen.</label>
                      </div>
                    </div>
                    <SOSlotModal
                      :modal-title="labelModalPaketExpress"
                      :modal-id="`pengerjaan-express${getIdOutlet}`"
                      @close="closeModal"
                    >
                      <template v-slot:modal-body>
                        <div v-if="pengerjaanExpress.isDelete">
                          <p class="f-16 f-c-black f-regular m-d-0">Yakin ingin menghapus paket express ini?</p>
                        </div>
                        <form :id="`pengerjaan-express${getIdOutlet}`" class="pengerjaan-express" v-if="!pengerjaanExpress.isDelete">
                          <div class="form-group">
                            <div class="m-t-12">
                                <SOInputRegular
                                  :title="'Nama Paket Express'"
                                  :placeholder="'Ketik Nama Paket'"
                                  :validation="'alphanumeric'"
                                  :required="true"
                                  v-model="paketExpress.nama"
                                />
                                <ErrorMessage
                                  ref="e_nama_paket_express"
                                  class="error"
                                  label="Nama Paket Express"
                                  :validation="$v.paketExpress.nama"
                                />
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="m-t-12">
                                <SOInputNominal
                                  :title="'Durasi Pengerjaan'"
                                  id="estimasi-paket"
                                  :use-comma="true"
                                  prefix="jam"
                                  :prefix-right="true"
                                  :default-value="inputNominal.durasi.formatted"
                                  :required="true"
                                  v-model="inputNominal.durasi"

                                />
                                <label for="estimasi-paket" class="f-12 f-regular f-c-midgrey">Estimasi penyelesaian pengerjaan express</label>
                                <ErrorMessage
                                  class="error"
                                  ref="e_durasi_paket_express"
                                  label="Durasi Pengerjaan"
                                  :validation="$v.paketExpress.durasi"
                                />
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="m-t-12">
                                <SOInputNominal
                                  :title="'Tarif'"
                                  id="tarif-paket"
                                  :use-comma="true"
                                  prefix="kali"
                                  :prefix-right="true"
                                  :default-value="inputNominal.tarif.formatted"
                                  :required="true"
                                  v-model="inputNominal.tarif"

                                />
                              <label for="tarif-paket" class="f-12 f-regular f-c-midgrey">Tarif akan dikalikan dengan total layanan.</label>
                                <ErrorMessage
                                  ref="e_tarif_paket_express"
                                  class="error"
                                  label="Tarif"
                                  :validation="$v.paketExpress.tarif"
                                />
                            </div>
                          </div>
                        </form>
                      </template>
                      <template v-slot:modal-footer>
                        <SOButton
                          :outline="true"
                          :full="true"
                          :text="`${pengerjaanExpress.isDelete ? 'Ya, Hapus' : 'Simpan Paket'}`"
                          :disable="isFetching || !validateAccess('transactionSetting.update')"
                          :loading="isFetching"
                          @action="clickPaketExpress"
                        />
                      </template>
                    </SOSlotModal>
                  </div>
                </div>

                <div class="p-d-72"></div>

                <div class="d-flex align-items-center col-md-12 col-sm-12 col-12 p-0 bg-white border-top">
                    <div class="p-x-20 w-100">
                        <button :disabled="!validateAccess('transactionSetting.update')" class="btn btn-login btn-long remove-margin"  id="Btntax" @click="postpajakV2">
                        <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                            v-if="isClicked === true">
                        </span>
                            <span id="txttax">Simpan</span>
                        </button>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
    import InputPresentase from "../../component-items/InputPersentase";
    import InputRupiah from "@/component-items/InputRupiah";
    import ErrorMessage from "@/component-items/ErrorMessage";
    import {minValue, required} from "vuelidate/lib/validators";
    import SOButtonPlusLink from "@/so-components/global/ui/SOButtonPlusLink.vue";
    import SOInputRegular from "@/so-components/global/input/SOInputRegular";
    import SOInputNominal from "@/so-components/global/input/SOInputNominal";
    import SOButton from "@/so-components/global/ui/SOButton";
    import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
    import connection from '@/store/utils/connection';

    export default {
        name: "TaxSetting",
        components: {
          InputPresentase,
          InputRupiah,
          ErrorMessage,
          SOInputRegular,
          SOButton,
          SOInputNominal,
          SOSlotModal,
          SOButtonPlusLink
        },
        props: ['setidoutlet'],
        data() {
            return {
                izinkan: '0',
                pajakinput: '',
                outlet: {},
                isClicked: false,
                // idoutlet: this.setidoutlet,
                dropoffWajibLunas: 0,
                hideCustomer: 0,
                regulerWajibLunas: 0,
                enableWajibBuktiTf: 0,
                isDiskon: 0,
                diskon: {
                    raw: 0,
                    formatted: ""
                },
                diskonRupiah: {
                  raw: 0,
                  formatted: ""
                },
                editableDiskon: 0,
                isPajak: 0,
                pajak: {
                    raw: 0,
                    formatted: ""
                },
                pajakRupiah: {
                  raw: 0,
                  formatted: ""
                },
                editablePajak: 0,

                isBiaya: 0,
                biaya: {
                    raw: 0,
                    formatted: ""
                },
                biayaRupiah: {
                  raw: 0,
                  formatted: ""
                },
                editableBiaya: 0,

                isBiayaPengantaran: 0,
                biayaPengantaran: {
                  raw: 0,
                  formatted: ""
                },
                biayaPengantaranRupiah: {
                  raw: 0,
                  formatted: ""
                },
                editableBiayaPengantaran: 0,

                isRupiah: {
                  diskon: false,
                  pajak: false,
                  biayaTambahan: true,
                  biayaPengantaran: true,
                },
                inputNominal: {
                  tarif:{
                    raw: 0,
                    formatted: ""
                  },
                  durasi:{
                    raw: 0,
                    formatted: ""
                  },
                },
                paketExpress: {
                  nama: '',
                  tarif: '',
                  durasi: '',
                  id:'',
                },
                pengerjaanExpress: {
                  isOpenPaket : false,
                  isDelete : false,
                  isEdit: false,
                  listPaket: [
                    {
                      nama: 'Paket Kilat 1',
                      idoutlet:'aaa',
                      tarif:1,
                      durasi:1
                    }
                  ]
                },
                isFetching: false,

                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },
            }
        },
        watch:{
          "inputNominal.durasi.raw" : function (newDurasi, oldDurasi) {
            if (newDurasi !== oldDurasi) {
              this.paketExpress.durasi = newDurasi;
            }
          },
          "inputNominal.tarif.raw" : function (newTarif, oldTarif) {
            if (newTarif !== oldTarif) {
              this.paketExpress.tarif = newTarif;
            }
          }
        },
        validations: {
          diskon: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          diskonRupiah: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          pajak: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          pajakRupiah: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          biaya: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          biayaRupiah: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          biayaPengantaran: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          biayaPengantaranRupiah: {
            raw: {
              required,
              minValue: (value) => value > 0,
            }
          },
          paketExpress : {
            nama: {
              required
            },
            durasi: {
              required,
              minValue: minValue(0.01)
            },
            tarif: {
              required,
              minValue: minValue(1)
            }
          },
        },
        mounted() {
            // this.idoutlet = this.setidoutlet.idoutlet;
            // this.detailoutlet();
            this.getpajak();
            this.getPaketExpress(this.getIdOutlet);
        },
        computed: {
          isPaketExpress: function () {
            return this.pengerjaanExpress.isOpenPaket
          },
          labelModalPaketExpress: function () {
            return this.pengerjaanExpress.isDelete ? "Hapus Paket Express" : "Paket Express";
          },
          listPaketExpress: function () {
            return this.pengerjaanExpress.listPaket
          },
          getIdOutlet: function () {
            return this.setidoutlet
          },
          apiEndPoint: function () {
            return {
              create : `${this.$baseurl}masterData/layanan/create_paket_express`,
              delete : `${this.$baseurl}masterData/layanan/delete_paket_express`,
              update : `${this.$baseurl}masterData/layanan/update_paket_express`,
              listData : `${this.$baseurl}masterData/layanan/paket_express`,
            }
          },
        },
        methods: {
            back() {
            	this.isDiskon = 0
	            this.isPajak = 0
	            this.isBiaya = 0
	            this.isBiayaPengantaran = 0
              this.isPengerjaanExpress = 0

              this.$emit('isdetail')
            },
            setPaketExpress(val) {
              this.pengerjaanExpress.isOpenPaket = val;
            },
            async getPaketExpress(idoutlet) {
              $('#loadingPage').show();
              $('#loadingPage').addClass('overlayLoading');

              try {
                const response = await connection.get(
                  this.apiEndPoint.listData,
                  { idoutlet }
                );

                if (response.status) {
                  this.pengerjaanExpress.listPaket = response.data.data;
                }
                $('#loadingPage').hide();
                $('#loadingPage').removeClass('overlayLoading');
              } catch (e) {
                this.$catch_error_response(e)
                $('#loadingPage').removeClass('overlayLoading');
                $('#loadingPage').hide();
              }
            },
            // async detailoutlet() {
            //     try {
            //         const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + this.setidoutlet, this.requestHeaders)
            //         this.outlet = response.data.data[0]
            //     } catch (e) {
            //     	this.$catch_error_response(e)
	          //       $('#loadingPage').hide();
	          //       $('#loadingPage').removeClass('overlayLoading');
            //     }
            // },
            decimal() {
                $('#inputtax').keydown(function (e) {
                    //Get the occurence of decimal operator
                    var match = $(this).val().match(/\./g);
                    if (match != null) {
                        // Allow: backspace, delete, tab, escape and enter
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }  // Ensure that it is a number and stop the keypress
                        else if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105) && (e.keyCode == 190)) {
                            e.preventDefault();
                        }
                    } else {
                        // Allow: backspace, delete, tab, escape, enter and .
                        if ($.inArray(e.keyCode, [46, 8, 9, 27, 13, 110, 190]) !== -1 ||
                            // Allow: Ctrl+A
                            (e.keyCode == 65 && e.ctrlKey === true) ||
                            // Allow: home, end, left, right
                            (e.keyCode >= 35 && e.keyCode <= 39)) {
                            // let it happen, don't do anything
                            return;
                        }
                        // Ensure that it is a number and stop the keypress
                        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault();
                        }
                    }
                });
                //Allow Upto Two decimal places value only
                $('#inputtax').keyup(function () {
                    if ($(this).val().indexOf('.') != -1) {
                        if ($(this).val().split(".")[1].length >= 2) {
                            if (isNaN(parseFloat(this.value))) return;
                            this.value = parseFloat(this.value).toFixed(2);
                        }
                    }
                });
            },

            onlynumberdiskon(event) {
                var nums = event.target.value;
                var number = nums.replace(/[^0-9,]+/, '');
                this.diskon = number;
            },

	          errorValidation() {
            	if ($("#customSwitchDiskon").is(":checked")) {
            		if (this.$v.diskon.raw.$invalid) {
			            this.$v.diskon.raw.$touch()
			            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
            			return true
		            }
	            }
            	if ($("#customSwitchPajak").is(":checked")) {
		            if (this.$v.pajak.raw.$invalid) {
			            this.$v.pajak.raw.$touch()
			            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
			            return true
		            }
	            }
            	if ($("#customSwitchBiaya").is(":checked")) {
		            if (this.$v.pajak.raw.$invalid) {
			            this.$v.pajak.raw.$touch()
			            this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
			            return true
		            }
	            }

            	return false
	          },
            // async postpajak() {
            // 	// if (this.errorValidation()) {
            // 	// 	return
	          //   // }
            //     this.isClicked = true
            //     $('#txttax').hide()
            //     $('#Btntax').prop('disabled', true);
            //     try {
            //         const post = new FormData;
            //         if(!this.isPajak){
            //             this.pajak.raw=0
            //             this.editablePajak=0
            //         }
            //         if(!this.isDiskon){
            //             this.diskon.raw=0
            //             this.editableDiskon=0
            //         }
            //         if(!this.isBiaya){
            //             this.biaya.raw=0
            //             this.editableBiaya=0
            //         }

            //         if (typeof this.editableDiskon === "boolean") {
	          //           this.editableDiskon = (this.editableDiskon) ? 1 : 0
            //         }
            //         if (typeof this.editablePajak === "boolean") {
	          //           this.editablePajak = (this.editablePajak) ? 1 : 0
            //         }
            //         if (typeof this.editableBiaya === "boolean") {
	          //           this.editableBiaya = (this.editableBiaya) ? 1 : 0
            //         }

            //         post.append('diskon', this.diskon.raw);
            //         post.append('editable_diskon', this.editableDiskon)
            //         post.append('pajak', this.pajak.raw);
            //         post.append('editable_pajak', this.editablePajak)
            //         post.append('biaya', this.biaya.raw);
            //         post.append('editable_biaya', this.editableBiaya)
            //         post.append('dropoff_wajib_lunas', (this.dropoffWajibLunas)?1:0);
            //         post.append('reguler_wajib_lunas', (this.regulerWajibLunas)?1:0);

            //         const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_pajak?idoutlet=' + this.setidoutlet, post, this.requestHeaders);
            //         if (response.data.status === true) {
            //             this.back();
            //             this.isClicked = false;
            //             $('#txttax').show();
            //             $('#Btntax').prop('disabled', false);
            //             this.$toast.success(response.data.msg)
            //         } else {
            //         	this.$toast.error(response.data.msg)
            //             this.isClicked = false;
            //             $('#txttax').show();
            //             $('#Btntax').prop('disabled', false);
            //         }
            //     } catch (e) {
            //     	this.$catch_error_response(e)
	          //       this.isClicked = false;
	          //       $('#txttax').show();
	          //       $('#Btntax').prop('disabled', false);
            //     }
            // },
            async postpajakV2() {
              this.isClicked = true
              $('#txttax').hide()
              $('#Btntax').prop('disabled', true);
              try {
                const post = new FormData;
                if(!this.isPajak){
                  this.pajak.raw=0
                  this.editablePajak=0
                }
                if(!this.isDiskon){
                  this.diskon.raw=0
                  this.editableDiskon=0
                }
                if(!this.isBiaya){
                  this.biaya.raw=0
                  this.biayaRupiah.raw = 0
                  this.editableBiaya=0
                }

                if (typeof this.editableDiskon === "boolean") {
                  this.editableDiskon = (this.editableDiskon) ? 1 : 0
                }
                if (typeof this.editablePajak === "boolean") {
                  this.editablePajak = (this.editablePajak) ? 1 : 0
                }
                if (typeof this.editableBiaya === "boolean") {
                  this.editableBiaya = (this.editableBiaya) ? 1 : 0
                }

                let enableExpress = this.pengerjaanExpress.isOpenPaket ? 1 : 0;

                post.append("pajak", this.pajak.raw)
                post.append('editable_pajak', this.editablePajak)
                post.append("diskon", this.diskon.raw)
                post.append('editable_diskon', this.editableDiskon)
                post.append("tipe_biaya", (this.isRupiah.biayaTambahan) ? 2 : 1)
                post.append("biaya", (this.isRupiah.biayaTambahan) ? this.biayaRupiah.raw : this.biaya.raw)
                post.append("editable_biaya", this.editableBiaya)
                post.append("dropoff_wajib_lunas", (this.dropoffWajibLunas) ? 1 : 0)
                post.append("reguler_wajib_lunas", (this.regulerWajibLunas) ? 1: 0)
                post.append("editable_pengantaran", (this.editableBiayaPengantaran) ? 1: 0)
                post.append("tarif_pengantaran", this.biayaPengantaranRupiah.raw)
                post.append("enable_express", enableExpress)
                post.append("hide_customer", (this.hideCustomer) ? 1: 0)
                post.append("enable_wajib_bukti_tf", (this.enableWajibBuktiTf) ? 1: 0)

                const response = await this.$axios.post(this.$baseurl + '/masterData/outlet/update_pajak_v2?idoutlet=' + this.setidoutlet, post, this.requestHeaders);
                if (response.data.status === true) {
                  this.back();
                  this.isClicked = false;
                  $('#txttax').show();
                  $('#Btntax').prop('disabled', false);
                  this.$toast.success(response.data.msg)
                } else {
                  this.$toast.error(response.data.msg)
                  this.isClicked = false;
                  $('#txttax').show();
                  $('#Btntax').prop('disabled', false);
                }
              } catch (e) {
                this.$catch_error_response(e)
                this.isClicked = false;
                $('#txttax').show();
                $('#Btntax').prop('disabled', false);
              }
            },
            async getpajak() {
                $('#loadingPage').show();
                $('#loadingPage').addClass('overlayLoading');
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/detail_outlet_meta?idoutlet=' + this.setidoutlet, this.requestHeaders);
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            $('#loadingPage').hide();
                            $('#loadingPage').removeClass('overlayLoading');
                            var detail= response.data.data[0];
                            this.enableWajibBuktiTf = detail.wajib_bukti_tf

                            this.regulerWajibLunas=detail.reguler_wajib_lunas===1
                            this.dropoffWajibLunas=detail.dropoff_wajib_lunas===1
                            this.hideCustomer=detail.hide_customer===1
                            this.diskon.raw=detail.diskon*100
	                        this.diskon.formatted = this.diskon.raw.toString().replace(".", ",")
                            if(detail.diskon>0 || detail.editable_diskon === 1){
                                this.isDiskon=1
                            } else {
	                            this.isDiskon=0
                            }
                            this.editableDiskon=detail.editable_diskon

                            this.pajak.raw=detail.pajak*100
	                        this.pajak.formatted = this.pajak.raw.toString().replace(".", ",")
                            if(detail.pajak>0 || detail.editable_pajak === 1){
                                this.isPajak=1
                            } else {
	                            this.isPajak=0
                            }
                            this.editablePajak=detail.editable_pajak

	                        if (detail.biaya_tipe == 1 || detail.biaya_tipe == 0) {
		                        this.biaya.raw=detail.biaya*100
		                        this.biaya.formatted = this.biaya.raw.toString().replace(".", ",")

		                        this.isRupiah.biayaTambahan = false
	                        } else {
	                        	this.biayaRupiah.raw=detail.biaya
		                        this.biayaRupiah.formatted=detail.biaya.toString()

		                        this.isRupiah.biayaTambahan = true
	                        }

                            if(detail.biaya>0 || detail.editable_biaya === 1){
                                this.isBiaya=1
                            } else {
	                            this.isBiaya=0
                            }
                            this.editableBiaya=detail.editable_biaya


	                        this.biayaPengantaranRupiah.raw = detail.biaya_pengantaran
	                        this.biayaPengantaranRupiah.formatted = detail.biaya_pengantaran.toString()
	                        if (this.biayaPengantaranRupiah.raw > 0) {
	                        	this.isBiayaPengantaran = 1
	                        } else {
		                        this.isBiayaPengantaran = 0
	                        }
                            this.editableBiayaPengantaran = detail.editable_biaya_pengantaran
                        }
                    }
                } catch (e) {
                	this.$catch_error_response(e)
	                $('#loadingPage').hide();
	                $('#loadingPage').removeClass('overlayLoading');
                }
            },
            setDeletePengerjaanExpress(val) {
              this.pengerjaanExpress.isDelete = val
            },
            setUpdatePengerjaanExpress(val) {
              this.pengerjaanExpress.isEdit = val
            },
            async addPaket() {
              await this.resetValidationNewPaket();
              await this.setDeletePengerjaanExpress(false);
              await this.setUpdatePengerjaanExpress(false);
              await this.openModal();
            },
            resetValidationNewPaket() {
              this.$refs.e_durasi_paket_express.resetValidation();
              this.$refs.e_nama_paket_express.resetValidation();
              this.$refs.e_tarif_paket_express.resetValidation();
            },
            async updatePaket (paket) {
              this.paketExpress.nama = paket.nama;
              this.paketExpress.idoutlet = paket.idoutlet;
              this.paketExpress.id = paket.id;

              this.inputNominal.tarif.raw = paket.tarif;
              this.inputNominal.tarif.formatted = paket.tarif.toString().replace(".", ",");
              this.inputNominal.durasi.raw = paket.durasi;
              this.inputNominal.durasi.formatted = paket.durasi.toString().replace(".", ",");

              await this.setDeletePengerjaanExpress(false)
              await this.setUpdatePengerjaanExpress(true)
              await this.openModal()
            },
            async deletePaket(paket) {
              this.paketExpress.nama = paket.nama;
              this.paketExpress.idoutlet = paket.idoutlet;
              this.paketExpress.id = paket.id;

              await this.setDeletePengerjaanExpress(true)
              await this.setUpdatePengerjaanExpress(false)
              await this.openModal()
            },
            validatePaketExpress() {
              this.$v.paketExpress.nama.$touch();
              this.$v.paketExpress.durasi.$touch();
              this.$v.paketExpress.tarif.$touch();

              return this.$v.paketExpress.nama.$invalid || this.$v.paketExpress.durasi.$invalid || this.$v.paketExpress.tarif.$invalid;
            },
            clickPaketExpress() {
              if (this.pengerjaanExpress.isDelete) {
                this.deletePaketExpress()
              } else {
                this.savePaketExpress()
              }
            },
            async savePaketExpress() {
              if (this.validatePaketExpress()) {
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu")
                return
              }
              this.isFetching = true;
              try {
                let { paketExpress } = this;
                let posted = new FormData();

                Object.keys(paketExpress).forEach(function (key) {
                  posted.append(key, paketExpress[key])
                })

                posted.append("idoutlet", this.getIdOutlet)

                let url = this.pengerjaanExpress.isEdit ? this.apiEndPoint.update : this.apiEndPoint.create;

                const response = await connection.post(
                    url,
                    posted,
                    connection.contentType.form
                );

                if (response.data.status === true) {
                    this.closeModal();
                    this.getPaketExpress(this.getIdOutlet);
                    this.$toast.success(response.data.msg)
                } else {
                    this.$toast.error(response.data.msg)
                }
                this.isFetching = false;
              } catch (e) {
                this.$catch_error_response(e)
                this.isFetching = false;
              }
            },
            async deletePaketExpress () {
              this.isFetching = true;
              try {
                let { paketExpress } = this;
                let posted = new FormData();

                Object.keys(paketExpress).forEach(function (key) {
                  if (key === "id") posted.append(key, paketExpress[key])
                })

                const response = await connection.post(
                    this.apiEndPoint.delete,
                    posted,
                    connection.contentType.form
                );

                if (response.data.status === true) {
                  this.closeModal();
                  this.getPaketExpress(paketExpress.idoutlet);
                  this.$toast.success(response.data.msg)
                } else {
                  this.$toast.error(response.data.msg)
                }

                this.isFetching = false;
              } catch (e) {
                this.$catch_error_response(e)
                this.isFetching = false;
              }
            },
            openModal() {
              $(`#pengerjaan-express${this.getIdOutlet}`).modal("show");
            },
            closeModal() {
              this.paketExpress = {
                  nama: '',
                  idoutlet:this.getIdOutlet,
                  tarif: '',
                  durasi: '',
                  id:'',
                }

                this.inputNominal = {
                  tarif:{
                    raw: 0,
                    formatted: ""
                  },
                  durasi:{
                    raw: 0,
                    formatted: ""
                  },
                }
              $(`#pengerjaan-express${this.getIdOutlet}`).modal("hide");
            }
        },

    }
</script>

<style scoped>
.list-paket-express{
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: auto;
  border: 1px solid #C8D0DD;
  padding: 10px 18px;
  box-sizing: border-box;
  border-radius: 3px;
  margin-bottom: 12px;
}

.list-paket-express div:nth-child(2) {
  grid-row: span 2 / span 2;
  justify-self: end;
  align-self: center;
}

span.dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 9999px;
  background-color: #6F7287;
  margin-bottom: 3px;
}

</style>